/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionChecked: {
  name: 'temp-selection-checked';
  data: string;
} = {
  name: 'temp-selection-checked',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 0 0-1H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V7a.5.5 0 0 0-1 0v7a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2Zm13.854.354a.5.5 0 0 0-.708-.708L7 9.293 5.354 7.646a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l8-8Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
